// src/components/ScrollHandler.tsx
import React, { useEffect, useState } from 'react';

const ScrollHandler: React.FC = () => {
    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        let scrollTimeout: NodeJS.Timeout;

        // Обработчик прокрутки
        const handleScroll = () => {
            setIsScrolling(true); // Полоса прокрутки становится видимой
            clearTimeout(scrollTimeout); // Сбрасываем таймер

            // Убираем класс через 500ms после прекращения прокрутки
            scrollTimeout = setTimeout(() => {
                setIsScrolling(false);
            }, 500);
        };

        // Добавляем обработчик прокрутки на весь документ
        window.addEventListener('scroll', handleScroll, { passive: true });

        // Применяем класс .scrolling, чтобы показать полосу прокрутки
        document.body.classList.toggle('scrolling', isScrolling);

        // Очистка при размонтировании компонента
        return () => {
            clearTimeout(scrollTimeout);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isScrolling]);

    return null; // Этот компонент ничего не рендерит, только управляет событиями
};

export default ScrollHandler;
